module.exports = __webpack_public_path__ + "img/google.7f1da22a.svg";